// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"styles_infoContainer__3Lfml","infoItem":"styles_infoItem__1ALay"};